/*
* ApplicationDetailsDLCM.jsx
* Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
* All rights reserved.
*/
import { Button, Container, Grid2, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import "./ApplicationDetailsDLCM.css";
import React from "react";

function ApplicationDetailsDLCM() {
  const dlcmButtonClick = () => {
    window.open("https://prelive.dlcm.vwgroup.com/","_blank", "noopener");
  };
   const submissionData = useSelector(
      (state) => state.submissionDetails.submissionDetails
    );
  return (
    <Container maxWidth="lg">
      <Grid2 container>
        <Grid2 size={12}>
          <section
            className="dlcm"
            id="dlcm-section"
            style={submissionData && Object.keys(submissionData).length > 0 && submissionData.status!=='DRAFT'?{ marginTop: "30px",borderBottom: '1px solid rgba(18, 20, 21, 0.2)'}:{marginTop: "30px",borderBottom:'0px'}}
          >
            <div className="dlcm-text-button" style={submissionData && Object.keys(submissionData).length > 0 && submissionData.status!=='DRAFT'?{width:'100%'}:{width:'94%'}}>
              <Typography
                sx={{
                  "font-weight": "bold !important",
                  "font-size": "20px !important",
                  "letter-spacing": "0.4px !important",
                  color: "rgba(18, 20, 21, 1) !important",
                }}
                className="uploadSignedApkText"
              >
                DLCM
              </Typography>
              <Button
                sx={{
                  border: "1px solid  #0476E2",
                  "font-weight": "400px !important",
                  color: "#0476E2 !important",
                  "font-size": "12px !important",
                  "letter-spacing": "0.4px !important",
                  "line-height": "19.6px",
                  "text-transform":"none !important"
                }}
                onClick={dlcmButtonClick}
              >
                Jump to DLCM CC
              </Button>
            </div>
            <div>
              <p className="dlcm-para-text" style={submissionData && Object.keys(submissionData).length > 0 && submissionData.status!=='DRAFT'?{width:'100%'}:{width:'85%'}}>
                Digital Lifecycle Management (DLCM) is a framework within the VW
                group how App Updates for Android apps should be rolled out via
                the App Store. One agreed precondition between CARIAD and the
                brands is the usage of the DLCM CC tool to track the approval
                workflow within the DLCM process framework. As a Group App
                Developer or CTPO you have to start the workflow within DLCM CC
                at least when you want to push your app on the RELEASE channel.
              </p>
            </div>
          </section>
        </Grid2>
      </Grid2>
    </Container>
  );
}

export default ApplicationDetailsDLCM;
